import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';

import { LabelService } from '../../../services/label.service';
import {
  InvoiceNotification,
  NewInvoice,
  TableInvoiceFields,
} from '../../../models/invoices';
import { InvoicesService } from '../../../services/invoices.service';

@Component({
  selector: 'app-invoices-notification-panel',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './invoices-notification-panel.component.html',
  styleUrl: './invoices-notification-panel.component.scss',
})
export class InvoicesNotificationPanelComponent implements OnInit {
  @Input() selectedInvoice: TableInvoiceFields | null = null;
  @Output() closePanel = new EventEmitter<void>();

  notifications: InvoiceNotification[] = [];

  constructor(
    public labelService: LabelService,
    private invoicesService: InvoicesService
  ) {}

  ngOnInit(): void {
    if (this.selectedInvoice) {
      this.invoicesService
        .getSDIInvoiceById(this.selectedInvoice.id)
        .subscribe({
          next: (invoice: NewInvoice) => {
            if (invoice.notifications) {
              this.notifications = invoice.notifications;
            }
          },
          error: (error) => {
            console.error('Error loading invoice:', error);
          },
        });
    }
  }

  getNotificationTypeDescription(type: string): string {
    switch (type) {
      case 'RC':
        return 'RC: Ricevuta Consegna';
      case 'MC':
        return 'MC: Mancata Consegna';
      case 'NS':
        return 'NS: Notifica di Scarto';
    }
    return '';
  }

  formatNotificationDate(dateString: string): string {
    const date = new Date(dateString);

    // Estrai giorno, mese, anno, ora e minuti
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Mesi 0-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Formatta come richiesto
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  onClose(): void {
    this.closePanel.emit();
  }
}
